<i class="fa shpass" [ngClass]='show ? "fa-eye" : "fa-eye-slash"' style="margin-top: {{ marginTop }}px" (click)='changeVisibility()'></i>